export class PartnerNotSelectedError extends Error {
  constructor() {
    super("Partner not selected");
  }
}
